import { EnvironmentConfig } from './environment.model';

// Ambiente do site DEV HOSPEDADO (Firebase Hosting `portal-cliente-v2-dev`,
// publicado a partir da branch `develop` — ver .github/workflows/
// firebase-deploy.yml). Diferente de `environment.ts`, que é só para
// `ng serve` local e usa caminhos `/proxy/*` relativos repassados pelo
// dev-server (ver proxy.conf.json). Quando o app roda hospedado NÃO existe
// dev-server para repassar `/proxy/*`, então aqui os hosts precisam ser
// ABSOLUTOS. Apontam para os hosts reais de HOMOLOGAÇÃO (mesmos de
// environment.hml.ts) — é o backend "de dev" disponível hoje.
//
// Quando existir um backend de dev próprio no futuro, troque os hosts abaixo
// aqui, sem mexer em environment.ts (local) nem environment.hml.ts.
export const environment: EnvironmentConfig = {
  production: false,
  envName: 'dev',
  // Legado por padrão: portal-cliente-v2-backend ainda não deployado (ver
  // environment.model.ts). Ligar só quando o backend novo estiver publicado.
  useV2Boot: false,
  apiUrls: {
    clientes: 'https://webapiclienteshomologacao.affixbeneficios.com.br/api/v1/',
    atendimento: 'https://webapiatendimentohomologacao.affixbeneficios.com.br/api/v1/',
    laserchip: 'https://webapilaserchiphomologacao.affixbeneficios.com.br/api/v1/',
    whatsapp: 'https://api-whatsapp.hml.affixtech.com.br/api/',
    salvavidas: 'https://api-salvavidas.hml.affixtech.com.br/api/v1/',
    precadastro: 'https://api-precadastro.hml.affixtech.com.br/api/',
    // Sem sufixo "homologacao" (ver environment.model.ts).
    arquivos: 'https://webapilaserchip.affixbeneficios.com.br/api/v1/',
    // TODO: apontar pro host real do portal-cliente-v2-backend assim que
    // estiver publicado em homologação — ainda não foi deployado.
    portalClienteV2: 'https://TODO-portal-cliente-v2-backend-hml/api/v1/',
  },
  // Token estático de parceiro (homologação) — não é segredo de usuário, é um
  // identificador estático público do app cliente (ver environment.model.ts).
  partnerToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwcmltYXJ5c2lkIjoiMiIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2xvY2FsaXR5IjoiRGV2ZWxvcG1lbnQiLCJjaGF2ZSI6ImUzYjBjNDQyOThmYzFjMTQ5YWZiZjRjODk5NmZiOTI0MjdhZTQxZTQ2NDliOTM0Y2E0OTU5OTFiNzg1MmI4NTUiLCJuYmYiOjE3MzY0NTU5MTgsImV4cCI6MjA1MTk4ODcxOCwiaWF0IjoxNzM2NDU1OTE4fQ.Usg3p59_ZR0HOtp7fn5i4C7LIE5qzb3T0TPr4E82c38',
};
